import styled from 'styled-components'
import { rem } from 'polished'
import { useIntl, FormattedMessage } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import { intlDateFormatter } from 'lib/datetime/dateUtils'
import { INTL_DAY_LONG_MONTH } from 'constants/dateFormats'
import Clickable from 'components/Common/Clickable'

const Container = styled(Clickable)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: ${rem(280)};
  height: ${rem(60)};
  padding: ${rem(12)} ${rem(20)};
  background: ${props => props.theme.palette.neutral.default.seven};
  border-radius: ${props => props.theme.borderRadius.L};
  transition: background-color 0.2s ease;

  &:hover {
    background: ${props => props.theme.palette.neutral.default.six};
  }
`

interface Props {
  title?: string
  updatedAt: string
  to: string
  onClick?: () => void
}

export default function ChatLandingRecentTripTile({ title, updatedAt, to, onClick }: Props) {
  const intl = useIntl()
  const formattedDate = intlDateFormatter(updatedAt, INTL_DAY_LONG_MONTH)

  const untitledLabel = intl.formatMessage({
    id: 'P7xyHLCCjSlOklqXsVYg',
    defaultMessage: 'Untitled',
    description: 'Default title for untitled trip in the trip planner feature',
  })

  return (
    <Container to={to} onClick={onClick}>
      <BodyText variant="medium" weight="normal" align="start" lineClamp={1}>
        {title ?? untitledLabel}
      </BodyText>
      <BodyText variant="small" weight="normal" align="start" colour="neutral-three" lineClamp={1}>
        <FormattedMessage
          id="6z0lgi4UgNsMosPKpK2B"
          defaultMessage="Last updated on {date}"
          values={{ date: formattedDate }}
          description="Last updated date label for recent trip tile in the trip planner"
        />
      </BodyText>
    </Container>
  )
}
